"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Item = exports.Grid = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Grid = _styledComponents["default"].div.withConfig({
  displayName: "Gridstyle__Grid",
  componentId: "atdb6w-0"
})(function (_ref) {
  var _ref2;

  var _ref$theme = _ref.theme,
      breakpoint = _ref$theme.breakpoint,
      spacing = _ref$theme.spacing,
      alignItems = _ref.alignItems,
      justify = _ref.justify;
  return _ref2 = {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: alignItems,
    justifyContent: justify,
    boxSizing: 'border-box',
    margin: "-".concat(spacing.inline['5xs']),
    height: '100%'
  }, _defineProperty(_ref2, breakpoint.sm(), {
    margin: "-".concat(spacing.inline['3xs'])
  }), _defineProperty(_ref2, breakpoint.md(), {
    margin: "-".concat(spacing.inline['4xs'])
  }), _ref2;
});

exports.Grid = Grid;

var width = function width(space) {
  return space && {
    flexGrow: 0,
    flexBasis: "".concat(space * 100, "%"),
    maxWidth: "".concat(space * 100, "%")
  };
};

var gridInspect = function gridInspect(_ref3) {
  var gutter = _ref3.gutter;
  return process.env.NODE_ENV !== 'production' && {
    'body.grid-inspect &': {
      boxShadow: "inset 0 0 0 ".concat(gutter, " #ff000033,\n      inset 0 0 0 1px #ff0000")
    }
  };
};

var Item = _styledComponents["default"].div.withConfig({
  displayName: "Gridstyle__Item",
  componentId: "atdb6w-1"
})(function (_ref4) {
  var _extends2;

  var _ref4$theme = _ref4.theme,
      breakpoint = _ref4$theme.breakpoint,
      spacing = _ref4$theme.spacing,
      xs = _ref4.xs,
      sm = _ref4.sm,
      md = _ref4.md,
      lg = _ref4.lg,
      xl = _ref4.xl;
  return _extends({
    boxSizing: 'border-box',
    padding: spacing.inset['4xs']
  }, gridInspect({
    gutter: spacing.inline['5xs']
  }), width(xs), (_extends2 = {}, _defineProperty(_extends2, breakpoint.sm(), _extends({
    padding: spacing.inset.xs
  }, gridInspect({
    gutter: spacing.inline['3xs']
  }), width(sm))), _defineProperty(_extends2, breakpoint.md(), _extends({
    padding: spacing.inset['2xs']
  }, gridInspect({
    gutter: spacing.inline['4xs']
  }), width(md))), _defineProperty(_extends2, breakpoint.lg(), width(lg)), _defineProperty(_extends2, breakpoint.xl(), width(xl)), _extends2));
});

exports.Item = Item;